export default "__VITE_ASSET__CzZ3sJqi__"